import { format } from 'date-fns';
import { IGetAllResponse, loadGetAll } from '../../../components/util';
import { string } from 'prop-types';
import { HttpRequest } from '../../../util/http';
import { ICommentCodeIndex } from '../../../containers/CommentDetails/lib/http'

export interface ISurvey {
  abbr: string
  canDelete: boolean
  coaching_template: string
  coaching_template_id: number
  drilldown_end: string
  drilldown_start: string
  id: number
  interviewField: string
  isHidden: number
  isMeasured: number
  label: string
  sort_order: null
  survey_id: number
}

export interface IQuestion {
  base_question: number;
  category: string;
  category_id: number;
  client: string;
  exclude_from_dashboards: number;
  qid: string;
  question_text: string;
  question_type: string;
  small_text: string;
  survey: string;
}

export interface IProject {
  coaching_form_use_other: number;
  default_avid: string;
  display: string;
  id: string;
  is_default_project: number;
  notifications_use_other: number;
}

export interface ISurveyReview {
  surveyDate: Date;


  survey: string;
  branchName: string;
  customerPhone: string;
  customerName: string;
  client: string;
  employeeName: string;
  externalDataReference: number
}

export interface ISurveyReviewOptions {
  newSurveys?: boolean
  completedSurveys?: boolean
  deletedSurveys?: boolean
  readyPublish?: boolean
}

export interface IMessage {
  message?: string
}

export interface IActionAlert {
  id?: number
  reason?: string
}

export interface IProcessComment extends ISurveyReview {
  defaultQid?: string
  defaultQidQuestionText?: string
  openEndedQuestions?: IOpenEndedQuestion[]
  surveyJson?: any
  isActionItem?: boolean
  doNotCall?: boolean
  isWoW?: boolean
  actionReason?: number
  dataStagingId?: number
}

export interface IOpenEndedQuestion {
  qid?: string
  label?: string
  comment?: string
  codes?: string[]
}

export interface IGetAllQuestionsResponse extends IGetAllResponse<IQuestion[]> {
  clientName: string;
}

export const GetAllProjects = () => {
  return loadGetAll<IProject>('/scripts/users/get_projects')
}

export const GetAllSurveys = (project: string) => {
  const data = { project }

  return loadGetAll<ISurvey>('/scripts/surveys_get', data)
}

// tslint:disable-next-line:variable-name
export const GetAllQuestions = (survey_abbr: string, projectId?: string) => {
  const data: any = { survey_abbr }
  const method = 'POST'

  if (projectId) {
    data.project = projectId;
  }

  return HttpRequest.fetch<IGetAllQuestionsResponse>('/scripts/questions_get_all', { data, method })
}

export const GetAllSurveyReviews = (options: ISurveyReviewOptions = {}) => {
  const method = 'POST';
  const data = options;

  return HttpRequest.fetch<ISurveyReview[]>('/scripts/survey_review/get_all', { method, data }).then((surveyReviews) => {
    if (surveyReviews.length > 0) {
      surveyReviews.forEach((surveyReview) => {
        surveyReview.surveyDate = new Date(surveyReview.surveyDate);
      });
    }

    return surveyReviews;
  });
};

export const DeleteSurveys = (surveys: ISurveyReview[]) => {
  const method = 'POST'
  const data = surveys;

  return HttpRequest.fetch<IMessage>('/scripts/survey_review/delete_surveys', { method, data }).then((message) => {
    return message
  })
}

export const GetSurveyDetails = (surveys: ISurveyReview[]) => {
  const method = 'POST'
  const data = surveys;

  return HttpRequest.fetch<IProcessComment[]>('/scripts/process_comments/get_details', { method, data }).then((message) => {
    return message
  })
}

export const GetActionReasons = () => {
  const method = 'POST'

  return HttpRequest.fetch<IActionAlert[]>('/scripts/coaching_form/getActionAlertReasons', { method }).then((reasons) => {
    return reasons
  })
}

export const SaveCurrentState = (surveys: ISurveyReview[]) => {
  const method = 'POST'
  const data = surveys

  return HttpRequest.fetch<any>('/scripts/process_comments/save_surveys', { method, data }).then((response) => {
    return response
  })
}

export const PublishSurveys = () => {
  const method = 'POST'
  const data = {}

  return HttpRequest.fetch<any>('/scripts/survey_review/publish', { method, data }).then((response) => {
    return response
  })
}

export const PublishSelectedSurveys = (surveys: ISurveyReview[]) => {
  const method = 'POST'
  const data = surveys

  return HttpRequest.fetch<any>('scripts/survey_review/publish_selected', { method, data }).then((response) => {
    return response;
  })
}
